<template>
  <div :class="['ui-textarea', classList]" @click="focus">
    <label v-if="label">
      {{ label }}
    </label>
    <div
      class="ui-textarea-container"
      :style="{ height: `${height}px` }"
    >
      <textarea
        ref="input"
        :style="{ resize: 'none' }"
        :autocomplete="autocomplete"
        :value="computedValue"
        :placeholder="placeholder"
        :name="name"
        :disabled="disabled"
        :readonly="readonly"
        :maxlength="maxLength"
        @focus="onFocus"
        @blur="onBlur"
        @input="onInput"
      />
    </div>
    <p v-if="computedError && computedError.length" class="error">
      {{ computedError }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'ui-textarea',
  props: {
    modelValue: {
      type: String,
      default: '',
    },

    label: {
      type: String,
      default: '',
    },

    placeholder: {
      type: String,
      default: '',
    },

    error: {
      type: [String, Boolean],
      default: '',
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    readonly: {
      type: Boolean,
      default: false,
    },

    name: {
      type: String,
      default: '',
    },

    autofocus: {
      type: Boolean,
      default: false,
    },

    autocomplete: {
      type: String,
      default: 'on',
    },

    height: {
      type: [Number, String],
      default: 120,
    },

    maxLength: {
      type: Number,
      default: 1000,
    },
  },

  data: () => ({
    focused: false,
  }),

  computed: {
    classList() {
      return [
        {
          error: !!this.computedError,
          disabled: this.disabled,
          readonly: this.readonly,
          focused: this.focused && !this.readonly,
        },
      ];
    },

    computedError() {
      return this.error;
    },

    computedValue() {
      return this.modelValue;
    },
  },

  mounted() {
    if (this.autofocus) {
      this.focus();
    }
  },

  methods: {
    onInput(e) {
      this.$emit('update:modelValue', e.target.value);
    },

    focus() {
      this.$refs.input.focus();
    },

    onFocus() {
      this.focused = true;
      this.$emit('focus');
    },
    onBlur() {
      this.focused = false;
      this.$emit('blur', this.modelValue?.length);
    },
  },
};
</script>

<style lang="scss">
.ui-textarea {

  label,
  p.error {
    display: block;
    font-size: 12px;
    line-height: 20px;
    color: $gray;
  }

  p.error {
    margin: 4px 0;
    color: $red;
  }

  &-container {
    width: 100%;
    padding: 6px;
    border: 1px solid $gray_lu;
    border-radius: 4px;
    overflow: hidden;
    transition: .2s ease border-color;
    background: $white;
  }

  &.error .ui-textarea-container {
    border-color: $red !important;
  }

  &.readonly,
  &.disabled {
    .ui-textarea-container {
      background: $gray_bgr;
    }
    input {
      box-shadow: 0 0 0 1000px $gray_bgr inset;
    }
  }

  &.disabled {
    pointer-events: none;

    input {
      color: $gray_l;
    }
  }

  &.readonly {
    pointer-events: auto;
  }

  &.focused {
    .ui-textarea-container {
      border-color: $black;
    }
  }

  textarea {
    flex: 1;
    height: 100%;
    width: 100%;
    padding: 6px;
    font-size: 14px;
    line-height: 20px;
    color: $black;
    border: none;
    outline: none;
    box-shadow: 0 0 0 1000px $white inset;
    resize: vertical;
    /* stylelint-disable-next-line */
    &::-webkit-input-placeholder {
      color: $gray;
      line-height: 20px;
      letter-spacing: normal;
      transition: .2s color ease;
      &:focus {
        color: transparent;
      }
    }
  }
}
@include breakpoint("desktop") {
  .ui-textarea {

    .ui-textarea-container:hover {
      border-color: $gray_l;
    }

    &.focused {
      .ui-textarea-container:hover {
        border-color: $black;
      }
    }

    &.readonly {
      .ui-textarea-container:hover {
        border-color: $gray_lu;
      }
    }
  }
}
</style>
